import { render, staticRenderFns } from "./DaxkoPager.vue?vue&type=template&id=6799ebd8"
import script from "./DaxkoPager.vue?vue&type=script&lang=js"
export * from "./DaxkoPager.vue?vue&type=script&lang=js"
import style0 from "./DaxkoPager.vue?vue&type=style&index=0&id=6799ebd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports